















































import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'

settings =
  name: "EventPricingBox"

  vue:
    props: ['event', 'actions']

    computed:
      eventDate: -> @$options.filters.formatDateWindow(@event.local_start_day, @event.local_end_day)
      eventTime: -> @$options.filters.formatTimeWindow(@event.local_start_time, @event.local_end_time)
      eventSpaces: -> @event.spaces

      bookNowCopy: ->
        eventIds = []
        eventIds = [...eventIds, ...booking.event_ids] for eventSetId, booking of @partnerBuy().bookings
        eventsCount = eventIds.length || 0
        copy = "Book 1 Listing Now!" if eventsCount is 1
        copy = "Book #{eventIds.length} Listings Now!" if eventsCount > 1
        copy ||= "Book Now!"
        copy

    methods:
      hiBookNow: ->
        @actions.add @event
        @storePartnerBuyToken()
        @navigate()

      partnerBuy: -> { ...@getAppSession('partnerBuy', {}) }

      storePartnerBuyToken: ->
        data = @partnerBuy()
        data.token = @$route.query.buy_partnership
        @setAppSession 'partnerBuy', data

      navigate: ->
        if @partnerBuy().brandRep
          @$router.push({ name: 'CampaignCreatePage' })
        else
          @$router.push({ name: 'BrandRepCreatePage' })

      quantityForSpace: (space) ->
        { formatNumber } = @$options.filters

        switch space.type
          when 'product_sampling' then "min #{formatNumber(space.min_quantity)}"
          else 1

      spaceNameFor: (space) ->
        { formatShortSpaceType } = @$options.filters
        formatShortSpaceType(space.type)

      spacePriceFor: (space) ->
        { formatMoney } = @$options.filters

        switch space.type
          when 'video_wall' then "$#{formatMoney(@priceForVideoWallInDollars(space))}"
          when 'product_sampling' then 'Varies'
          else "$#{formatMoney(space.supplier_price_in_dollars)}"

      priceForVideoWallInDollars: (space) -> PricingModel.priceForVideoWall @event, @$store.marketplace.standard_pricing_table
      minPriceForProductSamplingInDollars: (space) -> PricingModel.priceForProductSampling space.min_quantity, @event, @$store.marketplace.standard_pricing_table
      maxPriceForProductSamplingInDollars: (space) -> PricingModel.priceForProductSampling space.max_quantity, @event, @$store.marketplace.standard_pricing_table

export default VueOptions.vue settings
